import { combineReducers } from "@reduxjs/toolkit";

import authReducer from "./slices/authSlice";
import organisationReducer from "./slices/organisationSlice";
import subscriptionReducer from "./slices/subscriptionSlice";
import teamsReducer from "./slices/teamsSlice";
import tournamentReducer from "./slices/tournamentSlice";
import userReducer from "./slices/userSlice";
import publicTournamentReducer from "./slices/publicTournamentSlice";

const rootReducer = combineReducers({
  auth: authReducer,
  user: userReducer,
  organisation: organisationReducer,
  tournament: tournamentReducer,
  teams: teamsReducer,
  subscription: subscriptionReducer,
  publicTournament: publicTournamentReducer,
});

export default rootReducer;
